import React from "react"
import styled, {ThemeProvider} from "styled-components";
import {Link} from "gatsby"
import {withCookies, Cookies} from 'react-cookie';
import {instanceOf} from "prop-types";
import {Button, WireframeButton} from "../style/itf-styled-components";
import {useThemes} from "../style/themes.hook";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 1;
`;

const Container = styled.div`
  background-color: ${props => props.theme.background()};
  color: ${props => props.theme.colors.neutrals.textDefault};
  display: grid;
  grid-row-gap: 10px;
  padding: 20px 25px 25px 25px;
  margin: 25px;
  
  @media (max-width: 550px) {
    flex-direction: column;
    justify-content: space-evenly;
  }
`;

const Message = styled.span`
  align-self: flex-end;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-self: flex-start;
  justify-content: space-between;
  width: 350px;
  
  @media (max-width: 550px) {
    flex-direction: column;
    width: 100%;
    align-self: center;
  }
`;

const AcceptCookies = styled(Button)`
  background-color: #ff72f6;
  color: #ffffff;

  @media (max-width: 550px) {
    margin: 5px 0;
    width: 100%;
    text-align: center;
  }
`;

class CookiesConsent extends React.Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      showCookieConsent: false
    };
  }

  componentDidMount = async () => {
    const { cookies } = this.props;
    const acceptCookies = await cookies.get('acceptCookies');

    this.setState({
      showCookieConsent: !acceptCookies
    });
  };

  onAcceptCookies = () => {
    const { cookies } = this.props;

    cookies.set(
      'acceptCookies',
      true,
      {
        path: '/',
        maxAge: 31536000,
      }
    );

    this.setState({
      showCookieConsent: false
    });
  };

  render() {
    const themes = useThemes();
    const { showCookieConsent } = this.state;

    return (
      <>
        {showCookieConsent && (
          <ThemeProvider theme={themes['light']}>
            <Overlay>
              <Container>
                <Message>Folosim cookie-uri pentru a-ți asigura cea mai bună experiență de navigare pe site-ul nostru.</Message>
                <ButtonsContainer>
                  <WireframeButton as={Link} to="/politica-de-confidentialitate/">Află mai multe</WireframeButton>
                  <AcceptCookies onClick={this.onAcceptCookies}>Acceptă cookie-urile</AcceptCookies>
                </ButtonsContainer>
              </Container>
            </Overlay>
          </ThemeProvider>
        )}
      </>
    )
  }
}

export default withCookies(CookiesConsent);
